import { useState } from "react";
import { Barbell, Timer, Heart, Flame, Path, CaretRight } from "@phosphor-icons/react";
import WorkoutDetailSheet from "./WorkoutDetailSheet";

const zoneColors = ["hsl(220 10% 30%)", "#4dabf5", "#00e676", "#ffea00", "#ff9100", "#ff3b30"];
const zoneLabels = ["Зона 0", "Зона 1", "Зона 2", "Зона 3", "Зона 4", "Зона 5"];

export default function WorkoutsList({ workouts, maxHr }) {
  const [selected, setSelected] = useState(null);
  if (!workouts?.length) {
    return <p className="p-6 text-sm text-muted-foreground" data-testid="workouts-empty">Нет тренировок за выбранный период</p>;
  }
  return (
    <div className="space-y-3" data-testid="workouts-list">
      <p className="text-xs text-muted-foreground">Нажмите на тренировку, чтобы открыть детальную аналитику</p>
      {workouts.map((w) => {
        const totalZone = w.zones.reduce((a, b) => a + b, 0) || 1;
        return (
          <button key={w.id} onClick={() => setSelected(w)}
            className="w-full text-left glass-card p-4 hover:border-primary/40 hover:bg-secondary/30 transition-colors"
            data-testid={`workout-card-${w.id}`}>
            <div className="flex items-center gap-3 mb-3">
              <div className="w-9 h-9 rounded-md bg-primary/15 flex items-center justify-center">
                <Barbell size={18} weight="duotone" className="text-primary" />
              </div>
              <div className="flex-1">
                <div className="text-sm font-semibold">{w.sport}</div>
                <div className="text-xs text-muted-foreground num">{w.date} · {w.time}</div>
              </div>
              {w.strain != null && (
                <div className="text-right">
                  <div className="font-heading text-xl font-bold num text-primary">{w.strain}</div>
                  <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Нагрузка</div>
                </div>
              )}
              <CaretRight size={16} className="text-muted-foreground" />
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-xs mb-3">
              <span className="flex items-center gap-1.5 text-muted-foreground"><Timer size={14} /><span className="num text-foreground">{w.duration_min ?? "—"} мин</span></span>
              <span className="flex items-center gap-1.5 text-muted-foreground"><Heart size={14} /><span className="num text-foreground">{w.avg_hr ?? "—"} / {w.max_hr ?? "—"} уд</span></span>
              <span className="flex items-center gap-1.5 text-muted-foreground"><Flame size={14} /><span className="num text-foreground">{w.kcal ?? "—"} ккал</span></span>
              <span className="flex items-center gap-1.5 text-muted-foreground"><Path size={14} /><span className="num text-foreground">{w.distance_km != null ? `${w.distance_km} км` : "—"}</span></span>
            </div>
            <div className="flex h-2 rounded-full overflow-hidden gap-px" title="Пульсовые зоны">
              {w.zones.map((z, i) => z > 0 && (
                <div key={i} style={{ width: `${(z / totalZone) * 100}%`, background: zoneColors[i] }} title={`${zoneLabels[i]}: ${z} мин`} />
              ))}
            </div>
          </button>
        );
      })}
      <WorkoutDetailSheet workout={selected} workouts={workouts} maxHr={maxHr} onClose={() => setSelected(null)} />
    </div>
  );
}
